import type { IAppState } from 'services/app-state-provider';
import { type Bot } from 'services/connectivity/configuration-api/bots/types';
import { AgentBotActions } from 'store/entities/bots/actions';

export function handleBotDeleted(payload: Pick<Bot, 'id'>, store: IAppState): void {
  store.dispatch(AgentBotActions.botRemove({ login: payload.id }));
}
